import { StoredQueryModel } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const fetchQueries = actionCreator('[queries] FETCH_QUERIES');

export const fetchQueriesSuccess = actionCreator<{
  storedQueries: StoredQueryModel[];
}>('[queries] FETCH_QUERIES_SUCCESS');
